export function request (params, pagination) {
  return [
    { s: 'GOOG', c: 'Alphabet Inc.', v: 'NQ', t: 0 },
    { s: 'OTCM', c: 'OTC Markets Group Inc.', v: 'PS', t: 1 },
    { s: 'VLKAY', c: 'Volkswagen AG', v: 'PS', t: 20 }
  ]
}
